var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"切换背景","placement":"bottom-start"}},[_c('el-switch',{staticClass:"change-theme-switch",on:{"change":_vm.changeTheme},model:{value:(_vm.isDark),callback:function ($$v) {_vm.isDark=$$v},expression:"isDark"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }